import angular from 'angular'

import { wrap } from 'lodash-es'

angular
  .module('ggs.html-player')
  .directive('ggsHtmlPlayer', HtmlPlayerComponent)

function HtmlPlayerComponent($parse, HtmlPlayer) {
  return {
    restrict: 'E',
    link($scope, $elm, $attr) {
      const setup = $scope.$eval($attr.ggsHtmlPlayerSetup)
      const media = $scope.$eval($attr.ggsHtmlPlayerMedia)
      const events = $scope.$eval($attr.ggsHtmlPlayerEvents)
      const sourceStyleGetter = wrap($scope, $parse($attr.ggsHtmlPlayerSourceStyle))
      const posterStyleGetter = wrap($scope, $parse($attr.ggsHtmlPlayerPosterStyle))
      const sourceStyleEmitter = $scope.$eval($attr.ggsHtmlPlayerSourceStyleEmitter)
      const posterStyleEmitter = $scope.$eval($attr.ggsHtmlPlayerPosterStyleEmitter)

      const htmlPlayer = HtmlPlayer(
        $elm,
        setup,
        media,
        events,
        sourceStyleGetter,
        posterStyleGetter,
        sourceStyleEmitter,
        posterStyleEmitter)

      $scope.$on('$destroy', htmlPlayer.destroy)
    }
  }
}
